import 'stacktable.js/stacktable.js';

(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.tables = {
    attach: function(context, settings) {

      const stackTables = function() {
        const $stackableTables = jQuery('table:not(.scrollable-table):not(.stacktable):not(.stacktable-ignore)');
        $stackableTables.once('stack-tables').each(function(index) {
          const $table = jQuery(this);
          $table.attr('id', 'responsive-table-' + index);
          jQuery('#responsive-table-' + index).stacktable();
        });

        jQuery('.stacktable.small-only tr td.st-key:first-child').each(function() {
          const $td = jQuery(this);
          const $th = jQuery('<th scope="row">' + $td.text() + '</th>');
          $td.replaceWith($th);
        });
        jQuery('.stacktable').find('[class=""], [class=" "], [class="  "]').removeAttr('class');
      };

      const scrollTables = function() {
        const $scrollTables = jQuery('.scrollable-table');
        $scrollTables.each(function() {
          const $table = jQuery(this);
          $table.once('scroll-table-wrap').wrap('<div class="table-scroll-wrap"></div>');
        });
      };

      const tableHeadingScopes = function() {
        const $tables = jQuery('table');
        $tables.each(function() {
          const $table = jQuery(this);
          const $thead = $table.find('thead');
          const $tbody = $table.find('tbody');

          $thead.find('th:not([scope])').attr('scope', 'col');
          $tbody.find('th:not([scope]):first-child').attr('scope', 'row');
          $table.find('th:empty[scope]').removeAttr('scope');
        });
      };

      const emptyCells = function() {
        jQuery('td, th').html(function(i, html) {
          return html.replace(/\s*&nbsp;\s*/g, '');
        });
      };

      const nasdaqTablesResponsive = function() {
        let $nasdaqTables = jQuery('.block-views-blocknasdaq-sec-block-1 .views-table');
        $nasdaqTables.once('alter-nasdaq-tables').each(function(index) {
          jQuery(this).attr('id', 'responsive-nasdaq-table-' + index);
          jQuery('#responsive-nasdaq-table-' + index).cardtable();
        });
      };

      jQuery(document).ready(function() {
        if (!window.tablesInit) {
          window.tablesInit = true;
          emptyCells();
          nasdaqTablesResponsive();
          stackTables();
          scrollTables();
          tableHeadingScopes();
        }
      });
    }
  };
})(jQuery, Drupal);
